module.exports = __webpack_public_path__ + "img/rabbit-002.2f31fff.webp";